/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnteResDto } from '../../models/ente-res-dto';

export interface EntiControllerGetOneEnteById$Params {
  id: number;
}

export function entiControllerGetOneEnteById(
  http: HttpClient,
  rootUrl: string,
  params: EntiControllerGetOneEnteById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<EnteResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    entiControllerGetOneEnteById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnteResDto>;
      }),
    );
}

entiControllerGetOneEnteById.PATH = '/admin/ente/id/{id}';
